import { createContext } from "react";
import { I18nContext } from "./types";

export const i18nContext = createContext<I18nContext>({
  textSortTooltip: "",
});
